module.exports = __webpack_public_path__ + "static/media/golfer-7-a.4c51876a.png";